import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isTokenValid } from '../api';

// Gate for the provider (hizmat ko'rsatuvchi) area: must be logged in as a
// provider with a still-valid token, otherwise back to login.
export default function ProviderRoute({ children }) {
  const { auth } = useAuth();
  if (!auth || auth.role !== 'provider') {
    return <Navigate to="/login" replace />;
  }
  if (!isTokenValid(auth.token)) {
    return <Navigate to="/login?expired=1" replace />;
  }
  return children;
}
